// src/client/lib/env.ts
// Reads VITE_* env vars from import.meta.env (Vite, runtime) with a fallback
// to process.env (Node, used under ts-jest/ESM in tests). Same dual-source
// pattern used by @admin/lib/env.
import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(40),
  VITE_SENTRY_DSN: z.string().url().optional(),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
});

type ViteMeta = { env?: Record<string, string | undefined> };
const viteEnv: Record<string, string | undefined> =
  (import.meta as ViteMeta).env ?? {};
const nodeEnv: Record<string, string | undefined> =
  typeof process !== 'undefined' && process.env ? process.env : {};
const raw = { ...nodeEnv, ...viteEnv };

export const env = schema.parse({
  VITE_SUPABASE_URL: raw['VITE_SUPABASE_URL'],
  VITE_SUPABASE_ANON_KEY: raw['VITE_SUPABASE_ANON_KEY'],
  VITE_SENTRY_DSN: raw['VITE_SENTRY_DSN'],
  VITE_APP_ENV: raw['VITE_APP_ENV'] ?? 'development',
});

export type AppEnv = typeof env;
